var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCellPhone = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 109,
    viewBox: "0 0 83 109",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.784 109c20.5-.026 37.22-3.473 37.216-7.675-.005-4.203-16.732-7.609-37.235-7.583-20.504.027-37.221 3.48-37.217 7.68.005 4.2 16.732 7.609 37.236 7.578z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79 78.905c-.405.52 4.565 2.862 4.565 5.223 0 1.982-1.74 5.354-2.642 6.9M35.848 84.371c-2.472.596-1.629 11.21-1.703 13.075",
    stroke: "#442E1D",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.944 91.827c0 1.11-1.987 2.008-4.44 2.008-2.452 0-4.439-.899-4.439-2.008s1.987-2.013 4.44-2.013c2.452 0 4.439.911 4.439 2.013zM29.674 103.19c.913.639 2.799-.456 4.211-2.447 1.413-1.992 1.816-4.122.901-4.77-.915-.65-2.8.455-4.211 2.444-1.41 1.99-1.816 4.143-.9 4.773z",
    fill: "#442E1D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.293.819 17.987 6.808a8.454 8.454 0 0 0-5.343 3.339 7.782 7.782 0 0 0-1.381 6.05.102.102 0 0 1 0 .027c1.922 9.447 3.94 19.598 5.765 29.826v.016c.685 3.657 3.943 17.135 4.586 20.75.67 3.755 1.363 7.633 2.08 11.45.818 4.34 5.16 7.19 9.687 6.35l32.303-5.986c4.524-.84 7.541-5.054 6.727-9.395-1.012-5.361-4.512-20.678-5.396-26.064-1.744-10.733-3.548-21.81-6.301-32.223-.48-2.332-.745-3.766-.747-3.78-.817-4.341-5.163-7.189-9.684-6.352l.01.003z",
    fill: "#D7D7D7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 2.107c3.522-.651 6.887 1.528 7.514 4.872 0 0 .279 1.48.779 3.931 4.199 15.844 8.763 42.741 11.83 59.058.628 3.339-1.717 6.582-5.239 7.236l-33.065 6.13c-3.521.653-6.887-1.524-7.524-4.864-1.44-7.608-5.313-24.983-6.738-32.59-1.806-10.16-3.817-20.273-5.866-30.398a5.958 5.958 0 0 1 1.073-4.636 6.622 6.622 0 0 1 4.173-2.61l33.063-6.13M50.555.149l-33.068 6.13a8.61 8.61 0 0 0-5.436 3.406 7.908 7.908 0 0 0-1.403 6.156v.026c1.948 9.612 4.007 19.945 5.857 30.35v.02c.699 3.72 3.968 17.263 4.622 20.931.682 3.817 1.388 7.774 2.119 11.659.83 4.42 5.249 7.32 9.849 6.466l33.065-6.13c4.605-.854 7.673-5.142 6.842-9.56-1.026-5.459-4.54-20.874-5.432-26.352-1.775-10.912-3.603-22.194-6.412-32.788-.48-2.385-.759-3.836-.761-3.85-.829-4.417-5.24-7.315-9.842-6.464z",
    fill: "#1B7690",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1 70.075c.616 3.28-1.562 6.437-4.866 7.05l-30.352 5.639c-3.304.61-6.482-1.552-7.1-4.833-1.404-7.477-5.267-24.707-6.665-32.17-1.776-9.97-3.743-19.899-5.75-29.814a6.004 6.004 0 0 1 .956-4.531 6.086 6.086 0 0 1 3.907-2.529l30.353-5.626a6.12 6.12 0 0 1 4.558.956 6.038 6.038 0 0 1 2.54 3.876s.275 1.45.762 3.857C63.51 27.503 68.087 54.068 71.1 70.075z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.457 63.921c.697 3.716-1.771 7.29-5.514 7.983l-24.58 4.549c-1.326.238-3.553-.16-5.258-2.83-2.05-3.31-5.857-23.254-8.084-34.492-1.487-7.502-2.477-14.23-3.772-20.05-.69-3.718.308-7.024 4.055-7.718C35.411 9.49 39.358 9.186 49.327 7.015c3.272-.715 6.967.313 8.168 5.009 3.539 13.664 8.389 38.183 10.962 51.897z",
    fill: "#B6ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.037 76.29c.113.597-.836.623-1.021.687l-7.308 1.355c-.418.05-1.028.277-1.201-.238l-.017-.086c-.113-.597.286-.701.887-.814l7.329-1.36c.6-.109 1.201-.223 1.314.375l.017.081z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.522 27.086a3.623 3.623 0 0 0 2.916-2.775 3.596 3.596 0 0 0-1.467-3.737 3.656 3.656 0 0 0-4.039-.083 3.598 3.598 0 0 0-1.622 3.673c.355 1.959 2.237 3.264 4.212 2.922zM31.072 32.145a3.855 3.855 0 0 0 3.102-2.957 3.827 3.827 0 0 0-1.567-3.975 3.89 3.89 0 0 0-4.299-.082 3.829 3.829 0 0 0-1.718 3.913c.38 2.081 2.383 3.467 4.482 3.1z",
    fill: "#F3B1B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.396 25.316c-.48-1.009-1.855-1.014-1.725.172.083.528.205 1.05.365 1.56-1.996-1.014-4.199-1.539-4.79-.716a1.66 1.66 0 0 0 .195 1.996c1.343 1.46 5.078 2.147 6.037.039a3.85 3.85 0 0 0-.082-3.05z",
    fill: "#442E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.836 28.481c4.54.895 9.905.873 12.252-2.16",
    stroke: "#442E1D",
    strokeWidth: 1.435,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.202 29.03c.76 2.227 2.095 11.548 6.998 8.665 2.448-1.431 2.016-7.692 1.86-9.906M29.633 21.889c1.11-.048 2.016-.182 2.883.315-1.27.307-2.402 1.008-3.589 1.352 1.513-.134 3.104.22 4.598.224-1.357.463-3.916 1.431-4.228 1.636M51.444 18.044c-1.06.336-1.953.517-2.602 1.283 1.3-.145 2.616.122 3.844.043-1.468.391-2.838 1.267-4.24 1.782 1.44-.029 4.168 0 4.537.09",
    stroke: "#442E1D",
    strokeWidth: 1.435,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12 18.721c.156-1.106 1.463-1.521 1.698-.35.084.527.127 1.06.13 1.593 1.597-1.562 3.538-2.72 4.353-2.113.564.489.734 1.289.418 1.963-.841 1.79-4.197 3.551-5.747 1.836a3.861 3.861 0 0 1-.852-2.929z",
    fill: "#442E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.258 35.176c-3.98.491-8.168-2.59-9.825-5.994M71.01 20.99c2.162 3.577-2.534 9.063-6.726 9.554",
    stroke: "#442E1D",
    strokeWidth: 1.435,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCellPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-cell-phone.5835a1871310f1a8848168d0e67f79a0.svg";